export default defineNuxtRouteMiddleware((to) => {
  // If destination already has a hash, do nothing.
  if (to.hash) return

  const preserved = process.client ? sessionStorage.getItem('tma:hash') : null
  if (!preserved) return

  // If there is a preserved hash, silently add it to the destination.
  // Use navigateTo and return it from middleware (Nuxt requirement).
  return navigateTo(
    {
      path: to.path,
      query: to.query,
      // "preserved" already includes the leading '#'
      hash: decodeURI(preserved),
    },
    { replace: true }, // avoid polluting history with same-page redirects
  )
})
